export default __webpack_public_path__ + "static/21-0e30500f194d46079920b9a9e65b6399.jpg";